import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router
    ) {}

    canActivate(): boolean {
        const userSession = this.authService.getCurrentSession();
        
        if (userSession) {
            return true;
        }
        
        this.router.navigate([environment.loginPath]);
        return false;
    }
}
